<template>
    <div>
        <div class="form-row mb-3">
            <div class="col col-12 col-md-6 d-flex flex-column">
                <az-input icon="fas fa-search" v-model="search" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Filtro
                </button>
            </div>
        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum filtro identificado.'" 
                icon="fas fa-exclamation-circle" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary">
                            #{{ dado.id_pesquisa_alerta }}
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary" v-if="dado.acessos && dado.acessos.length">
                                {{ dado.acessos.length }}
                            </span>

                            <button type="button" class="btn mx-2 btn-sm btn-outline-secondary" @click="acessos(dado)" title="Permissão de Acesso.">
                              <i class="fas fa-user-lock"></i>
                            </button>

                            <button type="button" class="btn btn-sm btn-primary" @click="pesquisar(dado)" title="Pequisar">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />
        <edicao-pesquisa-alerta ref="editfiltro" @refresh="load()" />

    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import EdicaoAcessos from '../../cadastros/shared/EdicaoAcessos.vue';
import EdicaoPesquisaAlerta from './EdicaoPesquisaAlerta.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            options_classes: [],
        }
    },

    props: ['local'],

    components: { 
        AzInput,
        AzEmptyState,
        EdicaoAcessos, 
        EdicaoPesquisaAlerta,
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },
    },

    methods: { 
        pesquisar (dado) { 
            this.$emit('pesquisar', dado);
        },

        acessos(item) { 
          this.$refs.acessos.abrir('App\\azure\\pesquisaAlerta', item.id_pesquisa_alerta);
        },

        incluir () { 
            this.$refs.editfiltro.incluir();
        },

        load () { 
            this.$util.load(this, { 
                service:'pesquisa_alertas',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },

        editar (item) { 
            if ( !item ) { 
                return;
            }

            this.$refs.editfiltro.editar(item);
        },

        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'pesquisa_alertas',
                dados: item,
            });

        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Pesquisa Clínica", path: "/pesquisa-clinica"},
                { name: "Filtros", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>